<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover">
            <template slot="header">
              <h4 class="card-title">Filter</h4>
              <div class="row">
                <div style="margin-left: 20px; margin-bottom: 20px">
                  <label for="startDate">Start Date</label>
                  <datepicker :readonly="true"
                              format="yyyy-MM-dd"
                              id="startDate"
                              name="start-date"
                              v-model="filterFrom"></datepicker>
                </div>
                <div style="margin-left: 20px; margin-bottom: 20px">
                  <label for="endDate">End Date</label>
                  <datepicker :readonly="true"
                              id="endDate"
                              format="yyyy-MM-dd"
                              name="end-date"
                              v-model="filterTo"></datepicker>
                </div>
                <div style="margin-left: 20px; margin-bottom: 20px">
                  <button class="btn btn-info btn-fill" v-on:click="filterData()">Filter
                  </button>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover">
            <template slot="header">
              <h4 class="card-title">Device data power <strong>{{ this.device.name }}</strong></h4>
              <p class="card-category"></p>
            </template>
            <l-table-params :columns="tableData.columns"
                            :data="tableData.data"
                            :map-name="tableData.mapName"
                            :map-value="tableData.mapValue"
                            class="table-hover table-striped">
            </l-table-params>
          </card>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

  import LTableParams from 'src/components/TableParams.vue'
  import Card from 'src/components/Cards/Card.vue'
  import Datepicker from 'vuejs-datepicker';
  import {encodeData} from "../../tools/UrlTools";
  import EventBus from "../../event-bus";
  import moment from 'moment-timezone';

  const Vue = window.Vue;

  const tableColumns = ['Timestamp', 'Panel Voltage', 'Panel Current', 'Battery Voltage', 'Battery Current',
    'Battery Temperature', 'Battery Status', 'Charging Status', 'Battery Soc', 'Temperature Inside'];
  const tableData = [{}];
  const tableMapName = {
    'Panel Voltage': 'powerPanelVoltage',
    'Panel Current': 'powerPanelCurrent',
    'Battery Voltage': 'powerBatteryVoltage',
    'Battery Current': 'powerBatteryCurrent',
    'Battery Temperature': 'powerBatteryTemperature',
    'Battery Status': 'powerBatteryStatus',
    'Charging Status': 'powerChargingStatus',
    'Battery Soc': 'powerBatterySoc',
    'Temperature Inside': 'powerTemperatureInside'
  };
  const tableMapValue = {
    'timestamp': {
      'type': 'timestamp',
    },
    'powerPanelVoltage': {
      'type': 'double',
      'fixed': 2,
      'unit': 'V'
    },
    'powerPanelCurrent': {
      'type': 'double',
      'fixed': 2,
      'unit': 'A'
    },
    'powerBatteryVoltage': {
      'type': 'double',
      'fixed': 2,
      'unit': 'V'
    },
    'powerBatteryCurrent': {
      'type': 'double',
      'fixed': 2,
      'unit': 'A'
    },
    'powerBatteryTemperature': {
      'type': 'double',
      'fixed': 2,
      'unit': '°C'
    },
    'powerBatterySoc': {
      'unit': '%'
    },
    'powerTemperatureInside': {
      'type': 'double',
      'fixed': 2,
      'unit': '°C'
    },
  };

  export default {
    name: "DeviceDataPowerPage",
    components: {
      LTableParams,
      Card,
      Datepicker
    },
    data() {
      return {
        filterFrom: moment().tz("Europe/Warsaw").format('YYYY-MM-DD'),
        filterTo: moment().tz("Europe/Warsaw").format('YYYY-MM-DD'),
        device: null,
        tableData: {
          columns: [...tableColumns],
          data: [...tableData],
          mapName: {...tableMapName},
          mapValue: {...tableMapValue},
        },
      }
    },
    mounted() {
      this.loadDevice();
    },

    methods: {
      loadDevice() {
        let url = 'device/' + this.$route.params.deviceId;

        if (this.$route.params.localizationHistoryId !== undefined) {
          url += '?localizationHistoryId=' + this.$route.params.localizationHistoryId;
        }

        this.$http.get(url)
          .then(result => {
            this.device = result.data;

            this.filterFrom = this.device.lastDataDate.slice(0, 10);
            this.filterTo = this.device.lastDataDate.slice(0, 10);

            EventBus.$emit('EVENT_PATHS', [["/#/devices/list", 'Devices'],
              ['/#/devices/details/' + this.$route.params.deviceId, this.device.name],
              ['/#/devices/data/power/' + this.$route.params.deviceId, 'Data']]);

            this.loadData(this.device.serial);
          }, error => {
            console.error(error);
          });
      },
      loadData(serial) {
        let url = 'data/power/' + serial;

        if (this.$route.params.localizationHistoryId !== undefined) {
          url += '/' + this.$route.params.localizationHistoryId;
        }

        let params = {};
        if (this.filterFrom !== null && this.filterFrom) {
          if (typeof this.filterFrom == 'string')
            params['from'] = this.filterFrom;
          else
            params['from'] = this.filterFrom.toISOString().slice(0, 10);
        }
        if (this.filterTo !== null && this.filterTo) {
          if (typeof this.filterTo == 'string')
            params['to'] = this.filterTo;
          else
            params['to'] = this.filterTo.toISOString().slice(0, 10);
        }

        if (Object.keys(params).length)
          url += '?' + encodeData(params);

        this.$http.get(url)
          .then(result => {
            this.tableData.data = result.data;
          }, error => {
            console.error(error);
          });
      },
      filterData() {
        this.loadData(this.device.serial);
      }
    }
  }


</script>
<style>
  .content {
    width: 100%;
    background: #f8f9fa;
  }

  .card-plain {
    margin-bottom: inherit;
  }

  .table-responsive {
    background: whitesmoke;
    border-color: #0e0e0e;
  }

  .card-body {
    background: #f8f9fa;
  }

  .cardPlain {
    margin: 10px;
    margin-top: 20px;
    background-color: #e5e5e5;
  }

  h5 {
    background: #E3E3E3;
  }

  .headStyle {
    background: cadetblue;
  }

  .filterDate {
    margin-bottom: 60px;

  }
</style>
